import { globalState } from '@codeleap/store'

export * as contributeStore from './contribute'
export * as profilePromptStore from './profilePrompt'
export * as onboardingContributeStore from './onboarding'
export * as impersonateStore from './impersonate'
export * as lessonStore from './lesson'
export * as onboardingLessonStore from './onboardingLesson'
export * as replyStore from './reply'
export * as achievementsStore from './achievements'

export const referralCodeStore = globalState<string>(null, { persistKey: 'REFERRAL_CODE' })
